import React from 'react';

import { ICategory } from 'hah-fe-core/dist/types/category';

interface IProps {
  category: ICategory;
}

const CategoryHeader = ({ category }: IProps) => (
  <div id="category-header" className="item ctg-header">
    <div className="stack">
      <h1 className="name">
        <span className="anchor-bar">
          <em data-gsap="grow" />
        </span>
        <span>{category.name}</span>
      </h1>
      <div className="description" dangerouslySetInnerHTML={{ __html: category.description }} />
    </div>
  </div>
);

export default CategoryHeader;
